<template>
  <div class="present-placeholder">
    <div class="present-placeholder__main">
      <div class="componata-container">
        <div class="grid-middle-noBottom">
          <div class="col-7_md-12">
            <div class="present-placeholder__presentation">
              <div class="present-placeholder__photo"><span></span></div>
            </div>
          </div>

          <div class="col-5_md-12">
            <div class="present-placeholder__go-back"></div>

            <div class="present-placeholder__card">
              <div class="present-placeholder__card-content">
                <div class="present-placeholder__title"><span></span><span></span></div>
                <div class="present-placeholder__delivery"></div>
                <div class="present-placeholder__price"><span></span><span></span></div>
                <div class="present-placeholder__form">
                  <div class="present-placeholder__quantity"></div>
                  <div class="present-placeholder__button"></div>
                </div>
              </div>

              <div class="present-placeholder__shortcuts">
                <div class="present-placeholder__shortcut"><span></span><span></span><span></span></div>
                <div class="present-placeholder__shortcut"><span></span><span></span><span></span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="present-placeholder__footer">
      <div class="componata-container">
        <div class="present-placeholder__usp-wrapper">
          <div class="grid-noBottom">
            <div class="col-4_xs-12">
              <div class="present-placeholder__usp">
                <div>
                  <span></span>
                </div>

                <div>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>

            <div class="col-4_xs-12">
              <div class="present-placeholder__usp">
                <div>
                  <span></span>
                </div>

                <div>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>

            <div class="col-4_xs-12">
              <div class="present-placeholder__usp">
                <div>
                  <span></span>
                </div>

                <div>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PresentPlaceholder'
};
</script>

<style lang="scss" scoped>
/**
 * PresentPlaceholder
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Placeholder for present hero
 * @since 2021-04-15
**/

$component: 'present-placeholder';

.#{$component} {
  background-color: $ink-light;

  &__main {
    [class^='grid-']:first-of-type {
      @include margin-top(- map-get($spacers, 4));
    }
  }

  &__presentation {
    position: relative;
  }

  &__photo {
    display: flex;
    width: 100%;
    height: auto;
    margin: 0 auto;
    aspect-ratio: 1 / 1;
    align-items: center;
    justify-content: center;

    span {
      width: 80%;
      aspect-ratio: 1 / 1;
      border-radius: $border-radius-lg;
      background-color: $ink-lighter;
      animation: fading 1.5s infinite;
    }
  }

  &__go-back {
    width: 70%;
    @include rfs(1rem, height);
    @include margin-bottom(map-get($spacers, 4));
    background-color: $sky;
    animation: fading 1.5s infinite;
  }

  &__card {
    border-radius: $border-radius-lg;
    background-color: $white;
    box-shadow: 5px 5px 30px rgba($ink, 0.4);
  }

  &__card-content {
    @include padding(map-get($spacers, 5));
    animation: fading 1.5s infinite;
  }

  &__title {
    @include margin-bottom(map-get($spacers, 4));

    span {
      display: block;
    }
    span:nth-child(1) {
      width: 90%;
      @include rfs(2.4rem, height);
      @include margin-bottom(map-get($spacers, 3));
      background-color: $sky-dark;
    }

    span:nth-child(2) {
      display: block;
      width: 70%;
      @include rfs(1.6rem, height);
      background-color: $sky;
    }
  }

  &__delivery {
    width: 40%;
    @include rfs(1.3rem, height);
    @include margin-bottom(map-get($spacers, 4));
    background-color: $sky-dark;
  }

  &__price {
    width: 30%;
    @include margin-bottom(map-get($spacers, 4));

    span {
      display: block;
    }
    span:nth-child(1) {
      width: 90%;
      @include rfs(2rem, height);
      @include margin-bottom(map-get($spacers, 1));
      background-color: $sky-dark;
    }

    span:nth-child(2) {
      display: block;
      width: 70%;
      @include rfs(1.3rem, height);
      background-color: $sky;
    }
  }

  &__form {
    display: flex;
  }

  &__quantity {
    width: 20%;
    @include rfs(2.8rem, height);
    @include margin-right(map-get($spacers, 3));
    border-radius: $border-radius-lg;
    background-color: $sky;
  }

  &__button {
    width: 40%;
    @include rfs(2.8rem, height);
    @include margin-right(map-get($spacers, 3));
    border-radius: 50px;
    background-color: $sky;
  }

  &__shortcuts {
    display: flex;
    border-bottom-left-radius: $border-radius-lg;
    border-bottom-right-radius: $border-radius-lg;
    background: $sky-lighter;
    box-shadow: inset 0px 4px 4px rgba($ink, 0.08);
  }

  &__shortcut {
    flex-basis: 50%;
    @include padding(map-get($spacers, 5));
    color: $ink;

    &:not(:first-child) {
      border-left: 1px solid $gray-ghost-fixed;
    }

    span {
      display: block;
      animation: fading 1.5s infinite;
    }

    span:nth-child(1) {
      display: inline-block;
      @include rfs(2.2rem, width);
      @include rfs(2.2rem, height);
      @include margin-bottom(map-get($spacers, 3));
      border-radius: $border-radius-sm;
      background-color: $sky-dark;
    }

    span:nth-child(2) {
      width: 60%;
      @include rfs(1.3rem, height);
      @include margin-bottom(map-get($spacers, 2));
      background-color: $sky-dark;
    }

    span:nth-child(3) {
      width: 90%;
      @include rfs(0.8rem, height);
      background-color: $sky;
    }
  }

  &__footer {
    @include padding-top(map-get($spacers, 5));
    @include padding-bottom(map-get($spacers, 5));
    background: rgba($ink, 0.2);
  }

  &__usp-wrapper {
    @include margin-left(25rem);
  }

  &__usp {
    display: flex;
    align-content: flex-start;
    align-items: flex-start;
    color: $white;
    animation: fading 1.5s infinite;

    > div {
      display: flex;

      &:nth-child(1) {
        @include rfs(4rem, width);
        @include rfs(4rem, height);
        @include margin-right(map-get($spacers, 3));
        border-radius: $border-radius;
        aspect-ratio: 1 / 1;
        background-color: $sky;
      }

      &:nth-child(2) {
        flex-direction: column;
        flex-basis: 100%;

        span {
          display: block;
          width: 100%;
          @include rfs(1.3rem, height);
          @include margin-bottom(map-get($spacers, 2));
          background-color: $sky;

          &:nth-child(2) {
            width: 50%;
          }
        }
      }
    }
  }

  @keyframes fading {
    0% {
    opacity: 1;
    }

    50% {
      opacity: 0.6;
    }

    100% {
      opacity: 1;
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__card {
      @include margin-bottom(map-get($spacers, 6));
    }

    &__usp-wrapper {
      margin-left: 0;
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &__presentation {
      @include margin-bottom(map-get($spacers, 2));
    }

    &__usp {
      flex-direction: column;
      align-items: flex-start;

      div:nth-child(1) {
        // margin-right: 0;
        @include margin-bottom(map-get($spacers, 3));
      }

      div:nth-child(2) {
        width: 100%;
      }
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    &__usp-wrapper div[class^='col-']:not(:last-child) {
      @include margin-bottom(map-get($spacers, 3));
    }

    &__usp {
      flex-direction: row;
      align-items: flex-start;

      div:nth-child(1) {
        margin-bottom: 0;
      }
    }
  }
}
</style>
